import subcategoryTypes from 'constants/subcategoryTypes';
import { SelectorOption } from 'types';

export const TRADING_OFFER_OPERATION_DOCUMENT_OPTIONS = [
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.IDENTITY_DOCUMENT,
    label: 'DocumentTypeIdentityDocument',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.OWNERSHIP_CERTIFICATE,
    label: 'DocumentTypeOwnershipCertificate',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.PAYMENT_JUSTIFICATION,
    label: 'DocumentTypePaymentJustification',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.CONTRACT_OR_AGREEMENT,
    label: 'DocumentTypeContractOrAgreement',
  },
  {
    value: subcategoryTypes.TRADING_OFFER_OPERATION.OTHER,
    label: 'DocumentTypeOther',
  },
] as SelectorOption[];

export const TRADING_OFFER_OPERATION_DOCUMENT_ACCEPT = '.pdf,.jpg,.jpeg,.png';
export const TRADING_OFFER_OPERATION_DOCUMENT_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
